<form *ngIf="form" [formGroup]="form">
  <ng-container *ngFor="let formContent of formData">
    <div class="jb-grid one-up grid-offset-l">
      <div>
        <div>
          <h2>{{ formContent.formTitle }}</h2>
          <h3>{{ formContent.formText }}</h3>
        </div>
        <div>
          <ng-container *ngFor="let fieldset of formContent.fieldset">
            <h3>{{ fieldset.formTitle }}</h3>
            <ng-container *ngIf="!!fieldset.field && fieldset.field.length">
              <ng-container *ngFor="let data of fieldset.field">
                <ng-container
                  *ngIf="
                    !!data.controlName &&
                    data.inputType === 'text' &&
                    data.autocomplete !== 'true'
                  "
                >
                  <div *ngIf="data.title">{{ data.title }}</div>
                  <jb-form-field-container class="pv3" [type]="data.type">
                    <jb-input-label>{{ data.description }}</jb-input-label>
                    <input
                      jbInput
                      type="text"
                      formControlName="{{ data.controlName }}"
                      [autocomplete]="do - not - show"
                      [maxlength]="data.maxLength"
                      [readonly]="data.readonly === 'true'"
                      [required]="data.mandatory === 'true'"
                      [autofocus]="data.autofocus === 'true'"
                    />
                    <jb-error
                      *ngFor="let validation of data.validation"
                      [forError]="
                        errorMap[validation.validation] || validation.validation
                      "
                    >
                      <span aria-hidden="true">{{
                        validation.errorMessage
                      }}</span>
                      <jb-sr-only
                        >Error: {{ validation.errorMessage }}</jb-sr-only
                      >
                    </jb-error>
                  </jb-form-field-container>
                </ng-container>
                <ng-container
                  *ngIf="!!data.controlName && data.inputType === 'email'"
                >
                  <div *ngIf="data.title">{{ data.title }}</div>
                  <jb-form-field-container class="pv3" [type]="data.type">
                    <jb-input-label>{{ data.description }}</jb-input-label>
                    <input
                      jbInput
                      type="email"
                      formControlName="{{ data.controlName }}"
                      email
                      [autocomplete]="do - not - show"
                      [maxlength]="data.maxLength"
                      [autofocus]="data.autofocus === 'true'"
                      [readonly]="data.readonly === 'true'"
                      [required]="data.mandatory === 'true'"
                    />
                    <jb-error
                      *ngFor="let validation of data.validation"
                      [forError]="
                        errorMap[validation.validation] || validation.validation
                      "
                    >
                      <span aria-hidden="true">{{
                        validation.errorMessage
                      }}</span>
                      <jb-sr-only
                        >Error: {{ validation.errorMessage }}</jb-sr-only
                      >
                    </jb-error>
                  </jb-form-field-container>
                </ng-container>
                <ng-container
                  *ngIf="!!data.controlName && data.inputType === 'number'"
                >
                  <div *ngIf="data.title">{{ data.title }}</div>
                  <jb-form-field-container class="pv3" [type]="data.type">
                    <jb-input-label>{{ data.description }}</jb-input-label>
                    <input
                      jbInput
                      type="text"
                      formControlName="{{ data.controlName }}"
                      [autocomplete]="do - not - show"
                      [maxlength]="data.maxLength"
                      [autofocus]="data.autofocus === 'true'"
                      [readonly]="data.readonly === 'true'"
                      [required]="data.mandatory === 'true'"
                    />
                    <jb-error
                      *ngFor="let validation of data.validation"
                      [forError]="
                        errorMap[validation.validation] || validation.validation
                      "
                    >
                      <span aria-hidden="true">{{
                        validation.errorMessage
                      }}</span>
                      <jb-sr-only
                        >Error: {{ validation.errorMessage }}</jb-sr-only
                      >
                    </jb-error>
                  </jb-form-field-container>
                </ng-container>
                <ng-container
                  *ngIf="
                    !!data.controlName &&
                    data.inputType === 'text' &&
                    data.autocomplete === 'true'
                  "
                >
                  <div *ngIf="data.title" class="mb2">{{ data.title }}</div>
                  <jb-autocomplete
                    class="db mb3"
                    (optionSelected)="emitValue($event, data.controlName)"
                    [options]="data.options"
                    [label]="data.placeholder"
                  >
                  </jb-autocomplete>
                </ng-container>
                <ng-container
                  *ngIf="!!data.controlName && data.inputType === 'checkbox'"
                >
                  <div class="mb2" *ngIf="data.title">{{ data.title }}</div>
                  <div class="mb3">
                    <ng-container *ngFor="let checkbox of data.options">
                      <jb-checkbox
                        class="db mr2"
                        [attr.name]="checkbox.type"
                        [checked]="checkbox.checked === 'true'"
                        [disabled]="checkbox.enabled === 'false'"
                      >
                        {{ checkbox.name }}
                      </jb-checkbox>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="!!data.controlName && data.inputType === 'radio'"
                >
                  <div *ngIf="data.title" class="mb2">{{ data.title }}</div>
                  <jb-form-field-container class="pv3">
                    <jb-radio-group
                      class="db mb3"
                      [isHorizontal]="data.horizontal"
                      [label]="data.legend"
                    >
                      <jb-radio
                        *ngFor="let option of data.options"
                        [value]="option.value"
                        [checked]="option.checked"
                        (valueChanged)="
                          radioButtonChange($event, data.controlName)
                        "
                      >
                        {{ option.name }}
                      </jb-radio>
                    </jb-radio-group>
                  </jb-form-field-container>
                </ng-container>
                <ng-container
                  *ngIf="
                    !!data.controlName &&
                    (data.inputType === 'select' ||
                      data.inputType === 'simpleSelect')
                  "
                >
                  <div class="mb2" *ngIf="data.title">{{ data.title }}</div>
                  <jb-form-field-container class="pv3">
                    <jb-select
                      class="mb3"
                      [type]="
                        data.inputType === 'simpleSelect'
                          ? 'simple'
                          : 'standard'
                      "
                      [placeholder]="!!data.title ? data.title : null"
                      [formControlName]="data.controlName"
                      [required]="data.mandatory === 'true'"
                      (opened)="selectStatus($event)"
                      (valueChanged)="selectChange($event, data.controlName)"
                    >
                      <jb-select-option
                        *ngFor="let item of data.options"
                        [name]="item.name"
                        [id]="item.id"
                        [value]="item.value"
                      >
                        {{ item.name }}
                      </jb-select-option>
                    </jb-select>
                    <jb-error forError="required">
                      <span aria-hidden="true">This field is required</span>
                      <jb-sr-only>Error: This field is required</jb-sr-only>
                    </jb-error>
                  </jb-form-field-container>
                </ng-container>
                <ng-container *ngIf="data.inputType === 'button'">
                  <button class="db" jbButton (click)="onSubmit()">
                    {{ data.buttonText }}
                  </button>
                  <!-- ERROR MESSAGE -->
                  <div
                    class="flex pl3 s-body error-messages"
                    *ngIf="submitting"
                  >
                    {{ formContent.errorTitle }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</form>
